import { render, staticRenderFns } from "./MedicalWriting.vue?vue&type=template&id=11936c5e&"
import script from "./MedicalWriting.vue?vue&type=script&lang=js&"
export * from "./MedicalWriting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports